export const TOKEN_KEY = 'kb-token'
export const ACT_AS_KEY = 'kb-act-as'
export const DATA_KEY = 'kb-mock-data'
export const CONTENT_KEY = 'kb-content-data'
/** 旧版全局回收站 key（迁移到按用户隔离后不再写入） */
export const TRASH_KEY_LEGACY = 'kb-trash-data'
export const TRASH_SECTION_REMAP_KEY_LEGACY = 'kb-trash-section-remap'
export const SIDEBAR_COLLAPSED_KEY = 'kb-sidebar-collapsed'
export const EDITOR_AUDIT_OPEN_KEY = 'kb-editor-audit-open'
export const THEME_KEY = 'kb-theme'

export function trashStorageKey(userId) {
  return userId != null ? `kb-trash-data:u${userId}` : TRASH_KEY_LEGACY
}

export function trashSectionRemapStorageKey(userId) {
  return userId != null
    ? `kb-trash-section-remap:u${userId}`
    : TRASH_SECTION_REMAP_KEY_LEGACY
}
